<div class="container mt-4">
    <!-- Floating Search Box -->
    <div class="row d-flex justify-content-end">
        <div class="col-lg-4 col-md-6 col-12">
            <div class="form-floating mb-3">
                <input type="text" class="form-control" [(ngModel)]="searchText" placeholder="Search..." />
                <label for="searchInput">Search</label>
            </div>
        </div>
    </div>

    <!-- Table -->
    <div class="table-responsive">
        <table class="table table-hover rounded overflow-hidden">
            <thead class="table-dark">
                <tr>
                    <th>S.No</th>
                    <th>Applicant Name</th>
                    <th>Course Details</th>
                    <th>Issued Date</th>
                    <th>Certificate View</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="certificateDetails | filter:searchText as filteredList">
                    <tr *ngFor="let admin of certificateDetails; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ admin?.applicantName || '-' }}</td>
                        <td>{{ admin?.courseDetails || "-" }}</td>
                        <td>{{ admin?.issueDate | date : "dd-MM-yyy"}}</td>
                        <td>
                            <button class="btn btn-primary rounded-2" (click)="openUrl(admin?.certificateCode)">View <span class="fa fa-eye"></span></button>
                        </td>
                    </tr>
                    <tr *ngIf="certificateDetails.length === 0">
                        <td colspan="5" class="text-center">No records found</td>
                    </tr>
                </ng-container>

            </tbody>
        </table>
    </div>
</div>